/**
 * @fileoverview Helper functions for Informe Operarios validations
 */

/**
 * Valida que el rango de fechas sea válido (máximo 60 días por defecto, 2 meses)
 * @param {Date|string|null} startDate - Fecha de inicio
 * @param {Date|string|null} endDate - Fecha de fin
 * @param {number} maxDays - Máximo de días permitidos (default: 60)
 * @returns {string|null} Mensaje de error si hay problema, null si es válido
 */
export function validateDateRange(startDate, endDate, maxDays = 60) {
  // Si alguna fecha es null, no validar (filtro opcional)
  if (!startDate || !endDate) {
    return null;
  }

  // Convertir a Date si es string
  const start = startDate instanceof Date ? startDate : new Date(startDate);
  const end = endDate instanceof Date ? endDate : new Date(endDate);

  // Validar que las fechas sean válidas
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return null; // Si las fechas no son válidas, dejar que el componente maneje el error
  }

  // Validar que la fecha de inicio sea anterior a la fecha de fin
  if (start > end) {
    return 'La fecha de inicio debe ser anterior a la fecha de fin';
  }

  // Calcular diferencia en días
  const diffTime = end.getTime() - start.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // Validar que no exceda el máximo de días
  if (diffDays > maxDays) {
    return 'El rango de fechas no puede exceder 60 días';
  }

  return null; // Rango válido
}

/**
 * Verifica si hay al menos un filtro activo
 * @param {Object} filters - Objeto con los filtros
 * @param {string|null} filters.operario - ID del operario seleccionado
 * @param {string|null} filters.proveedor - ID del proveedor seleccionado
 * @param {string|null} filters.orden - ID de la orden seleccionada
 * @param {string|null} filters.centroCosto - ID del centro de costo seleccionado
 * @param {Object} filters.fechaInicio - Rango de fecha de inicio {inicio, fin}
 * @param {Object} filters.fechaFin - Rango de fecha de fin {inicio, fin}
 * @returns {boolean} true si hay al menos un filtro activo, false en caso contrario
 */
export function hasActiveFilters(filters) {
  if (!filters) {
    return false;
  }

  // Verificar operario
  if (filters.operario) {
    return true;
  }

  // Verificar proveedor
  if (filters.proveedor) {
    return true;
  }

  // Verificar orden
  if (filters.orden) {
    return true;
  }

  // Verificar centro de costo
  if (filters.centroCosto) {
    return true;
  }

  // Verificar rango de fecha de inicio (ambas fechas deben estar presentes)
  if (filters.fechaInicio && filters.fechaInicio.inicio && filters.fechaInicio.fin) {
    return true;
  }

  // Verificar rango de fecha de fin (ambas fechas deben estar presentes)
  if (filters.fechaFin && filters.fechaFin.inicio && filters.fechaFin.fin) {
    return true;
  }

  return false;
}

